import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import Validator from 'validatorjs';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';

import {
  Form, Button, Modal, Header, Icon, Message,
} from 'semantic-ui-react';

import { utcMoment, dateTimeFormatted } from '../../utilities/dateUtils';

class AuctionAccessBlacklistForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: null,
      expirationDate: null,
      auctionAccessNo: '',
      notes: '',
      errors: {},
    };
  }

  componentDidMount() {
    const { auctionAccessBlacklist } = this.props;
    if (!isEmpty(auctionAccessBlacklist)) {
      const {
        id,
        expirationDate,
        auctionAccessNo,
        notes,
      } = auctionAccessBlacklist;

      this.setState({
        id,
        expirationDate,
        auctionAccessNo,
        notes,
      });
    }
  }

  render() {
    const {
      isModalOpen,
      onCloseHandler,
      onSubmitHandler,
      error,
      submitting,
      action,
    } = this.props;

    const {
      errors,
      id: stateId,
      expirationDate: stateExpirationDate,
      auctionAccessNo: stateAuctionAccessNo,
      notes: stateNotes,
    } = this.state;

    const date = isEmpty(stateExpirationDate)
      ? null
      : utcMoment(stateExpirationDate);

    const onChangeHandler = field => event => {
      this.setState({ [field]: event.target.value });
    };

    const onDateChangeHandler = field => dateValue => {
      this.setState({ [field]: moment(dateValue, 'YYYY-MM-DD') });
    };

    const validationRules = {
      auctionAccessNo: 'required',
    };

    const submitForm = () => {
      const validation = new Validator(this.state, validationRules);
      if (validation.fails()) {
        this.setState(prevState => ({ ...prevState, ...validation.errors }));
        return false;
      }
      onSubmitHandler({
        id: stateId,
        expirationDate: dateTimeFormatted(utcMoment(stateExpirationDate)),
        auctionAccessNo: stateAuctionAccessNo,
        notes: stateNotes,
      });
      this.setState(prevState => ({ ...prevState, ...validation.errors }));
      return true;
    };

    return (
      <Modal
        open={isModalOpen}
        closeIcon
        onClose={onCloseHandler}
        closeOnEscape={false}
        closeOnRootNodeClick={false}
      >
        <Modal.Header>
          {!stateId && 'Create New AuctionAccess Blacklist'}
          {stateId && 'Edit AuctionAccess Blacklist'}
        </Modal.Header>
        <Modal.Content image>
          <Modal.Description>
            {error && (
              <Message negative>
                <p>{error}</p>
              </Message>
            )}
            <Form>
              <Header size='small' color='blue' />
              <Form.Group widths='equal'>
                <Form.Field required error={!isEmpty(errors.auctionAccessNo)}>
                  <label htmlFor='auctionAccessNo'>Auction Access</label>
                  <input
                    id='auctionAccessNo'
                    name='auctionAccessNo'
                    value={stateAuctionAccessNo}
                    onChange={onChangeHandler('auctionAccessNo')}
                    readOnly={action === 'edit'}
                    className={action === 'edit' ? 'input-disabled' : ''}
                  />
                  {errors.auctionAccessNo && (
                    <span>{errors.auctionAccessNo}</span>
                  )}
                </Form.Field>
                <Form.Field>
                  <label htmlFor='expirationDate'>Expiration Date</label>
                  <DatePicker
                    id='expirationDate'
                    style={{ padding: '0', width: '100%' }}
                    selected={date}
                    onChange={onDateChangeHandler('expirationDate')}
                    showTimeSelect
                    timeFormat='HH:mm'
                    timeIntervals={15}
                    dateFormat='YYYY-MM-DD'
                  />
                </Form.Field>
              </Form.Group>
              <Form.Group widths='equal'>
                <Form.Field>
                  <label htmlFor='notes'>Notes</label>
                  <input
                    id='notes'
                    name='notes'
                    value={stateNotes}
                    onChange={onChangeHandler('notes')}
                  />
                </Form.Field>
              </Form.Group>
            </Form>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          {submitting && (
            <Button loading positive>
              Submitting...
            </Button>
          )}
          {!submitting
            && !stateId && (
              <Button color='green' onClick={submitForm} inverted>
                <Icon name='checkmark' /> Create
              </Button>
          )}

          {!submitting
            && stateId && (
              <Button color='green' onClick={submitForm} inverted>
                <Icon name='checkmark' /> Update
              </Button>
          )}
          <Button onClick={onCloseHandler}>Cancel</Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

AuctionAccessBlacklistForm.propTypes = {
  isModalOpen: PropTypes.bool,
  onCloseHandler: PropTypes.func,
  onSubmitHandler: PropTypes.func,
  error: PropTypes.string,
  submitting: PropTypes.bool,
  action: PropTypes.string,
  auctionAccessBlacklist: PropTypes.shape({
    id: PropTypes.number,
    expirationDate: PropTypes.string,
    auctionAccessNo: PropTypes.string,
    notes: PropTypes.string,
  }),
};

AuctionAccessBlacklistForm.defaultProps = {
  isModalOpen: false,
  onCloseHandler: () => {},
  onSubmitHandler: () => {},
  error: null,
  submitting: false,
  action: 'create',
  auctionAccessBlacklist: {},
};

export default AuctionAccessBlacklistForm;
